import React from 'react'
import { FormatMoney } from 'Utils/functions'
import { PAYMENT_NAMES } from 'Components/DocumentDetailIvend/constants'
import {
  getCreditCardLastFourDigits,
  getPaymentLabel,
  getPaymentType,
  getYappyConfirmationNumber,
} from 'Components/DocumentDetailIvend/utils/paymentTypesValidation'

export function PaymentTypeItem({ payment, creditNumber }) {
  const { isCreditCard, isCreditAccount, isCmf, isYappy } =
    getPaymentType(payment)
  const coincidence = Object.keys(PAYMENT_NAMES).find(key =>
    payment?.PaymentTypeId?.replace(/\s+/g, '').toLowerCase()?.includes(key)
  )
  const lastFourDigits = getCreditCardLastFourDigits(
    payment,
    isCreditCard,
    isCmf
  )
  const yappyConfirmationNumber = getYappyConfirmationNumber(payment)
  const paymentLabel = getPaymentLabel(
    payment,
    isCmf,
    isCreditCard,
    isCreditAccount,
    lastFourDigits,
    creditNumber
  )

  return (
    <p>
      {PAYMENT_NAMES[coincidence] || payment?.PaymentTypeId}
      {isYappy && yappyConfirmationNumber ? `${yappyConfirmationNumber} -` : ''}
      {paymentLabel}
      {FormatMoney(payment?.Amount || 0, false, 2, true)}
    </p>
  )
}
